// import {
//   Combobox,
//   ComboboxButton,
//   ComboboxInput,
//   ComboboxOption,
//   ComboboxOptions,
// } from "@headlessui/react";
// import { ChevronDownIcon } from "@heroicons/react/20/solid";
// import { useState } from "react";

// export default function GenericCombobox({
//   label,
//   options,
//   selected,
//   onChange,
//   displayKey,
//   disabled = false,
// }) {
//   const [query, setQuery] = useState("");
//   const [isFocused, setIsFocused] = useState(false);

//   const filteredOptions =
//     query === ""
//       ? options
//       : options.filter((item) =>
//           item[displayKey]?.toLowerCase().includes(query.toLowerCase())
//         );

//   return (
//     <div className="flex my-2 w-full ">
//       <label className="block text-sm font-medium mb-1">{label}</label>
//       <Combobox value={selected} onChange={onChange}>
//         <div className="relative flex-1">
//           <ComboboxInput
//             onChange={(event) => setQuery(event.target.value)}
//             disabled={disabled}
//             onFocus={() => setIsFocused(true)}
//             onBlur={() => setTimeout(() => setIsFocused(false), 150)}
//             className="block w-full rounded-none rounded-r border-0 px-3.5 py-2 text-gray-800 font-normal shadow-sm ring-1 ring-inset ring-secondaryHover
//             placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
//             displayValue={(item) => item?.[displayKey] || ""}
//             placeholder={`Select ${label}`}
//           />
//           <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-hidden">
//             <ChevronDownIcon
//               className="size-5 text-gray-400"
//               aria-hidden="true"
//             />
//           </ComboboxButton>
//           {(isFocused || query !== "") && (
//             <ComboboxOptions className="absolute z-10 w-full border border-cool-gray-200 mt-1 rounded shadow-md bg-textWhite max-h-60 overflow-y-auto">
//               {filteredOptions.length === 0 && query !== "" ? (
//                 <div className="px-2 py-1 text-cool-gray-400">
//                   No results found
//                 </div>
//               ) : (
//                 filteredOptions.map((item) => (
//                   <ComboboxOption
//                     key={
//                       item.id ||
//                       item.countryId ||
//                       item.stateId ||
//                       item.cityId ||
//                       item.areaId
//                     }
//                     value={item}
//                     className={({ active }) =>
//                       `px-2 py-1 text-cool-gray-600 font-light cursor-pointer ${
//                         active ? "bg-blue-500 text-white" : ""
//                       }`
//                     }
//                   >
//                     {item[displayKey]}
//                   </ComboboxOption>
//                 ))
//               )}
//             </ComboboxOptions>
//           )}
//         </div>
//       </Combobox>
//     </div>
//   );
// }

// GenericCombobox.jsx
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useMemo, useState } from "react";

export default function GenericCombobox({
  label,
  options,
  selected,
  onChange,
  displayKey,
  disabled = false,

  // ✅ NEW: force unique key selection
  keyField,
}) {
  const [query, setQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const filteredOptions = useMemo(() => {
    if (!Array.isArray(options)) return [];
    if (query === "") return options;

    return options.filter((item) =>
      String(item?.[displayKey] ?? "")
        .toLowerCase()
        .includes(query.toLowerCase())
    );
  }, [options, query, displayKey]);

  const getOptionKey = (item, idx) => {
    // 1) Prefer explicit keyField when provided
    if (keyField && item?.[keyField] != null)
      return `${keyField}:${item[keyField]}`;

    // 2) Otherwise pick the most specific known IDs (not countryId)
    if (item?.id != null) return `id:${item.id}`;
    if (item?.stateId != null) return `stateId:${item.stateId}`;
    if (item?.cityId != null) return `cityId:${item.cityId}`;
    if (item?.areaId != null) return `areaId:${item.areaId}`;
    if (item?.countryId != null) return `countryId:${item.countryId}`;

    // 3) Last resort (still unique within render)
    return `idx:${idx}`;
  };

  return (
    <div className="flex my-2 w-full ">
      <label className="block text-sm font-medium mb-1">{label}</label>

      <Combobox value={selected} onChange={onChange} disabled={disabled}>
        <div className="relative flex-1">
          <ComboboxInput
            onChange={(event) => setQuery(event.target.value)}
            disabled={disabled}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setTimeout(() => setIsFocused(false), 150)}
            className="block w-full rounded-none rounded-r border-0 px-3.5 py-2 text-gray-800 font-normal shadow-sm ring-1 ring-inset ring-secondaryHover
            placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
            displayValue={(item) => item?.[displayKey] || ""}
            placeholder={`Select ${label}`}
          />

          <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-hidden">
            <ChevronDownIcon
              className="size-5 text-gray-400"
              aria-hidden="true"
            />
          </ComboboxButton>

          {(isFocused || query !== "") && (
            <ComboboxOptions className="absolute z-10 w-full border border-cool-gray-200 mt-1 rounded shadow-md bg-textWhite max-h-60 overflow-y-auto">
              {filteredOptions.length === 0 && query !== "" ? (
                <div className="px-2 py-1 text-cool-gray-400">
                  No results found
                </div>
              ) : (
                filteredOptions.map((item, idx) => (
                  <ComboboxOption
                    key={getOptionKey(item, idx)}
                    value={item}
                    className={({ active }) =>
                      `px-2 py-1 text-cool-gray-600 font-light cursor-pointer ${
                        active ? "bg-blue-500 text-white" : ""
                      }`
                    }
                  >
                    {item?.[displayKey]}
                  </ComboboxOption>
                ))
              )}
            </ComboboxOptions>
          )}
        </div>
      </Combobox>
    </div>
  );
}
